<template>
  <div class="intake-sidebar d-flex flex-column">
    <div class="intake-sidebar__rooms">
      <button
        v-for="(room, roomIndex) in rooms"
        :key="roomIndex"
        :class="`${roomIndex === selectedRoomIndex ? 'is-active' : ''} btn--reset`"
        type="button"
        @click="() => setSelectedRoomIndex(roomIndex)"
      >
        <strong class="d-block">
          {{ room.title }} ({{ room.objects.length }})
        </strong>
      </button>
    </div>

    <div class="intake-sidebar__add">
      <div class="custom-select flex-grow-1 mr-1">
        <select v-model="roomTemplate">
          <option value="">Selecteer een kamer</option>

          <option
            v-for="(roomTemplate, index) in roomTemplates"
            :value="roomTemplate"
            :key="index"
          >
            {{ roomTemplate.title }}
          </option>
        </select>
      </div>

      <button
        class="btn btn--primary btn--sm btn--icon-only"
        type="button"
        @click="() => addRoom(roomTemplate)"
      >
        +
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      selectedRoomIndex: 'room/selectedRoomIndex',
      rooms: 'room/rooms',
      roomTemplates: 'room/roomTemplates',
    }),
  },

  data() {
    return {
      roomTemplate: '',
    };
  },

  methods: {
    ...mapMutations({
      addRoom: 'room/addRoom',
      setSelectedRoomIndex: 'room/setSelectedRoomIndex',
    }),
  },
};
</script>
